
import React from 'react';

const MutateConcept = (props) => {
  return (
    <div>
      <p className="step-p">Subsequent blocks will also be invalid.</p>
        
      <p className="step-p">A hash change will cause a mutation in the previous hash of subsequent blocks. Since previous hash is used to calculate the hash, subsequent hashes will also change. </p>

      <p className="step-p">This will lead to a cascading invalidation of blocks.</p>
      
      <p><b>Try it yourself:</b></p>
      <p className="step-p"> Add 3 blocks, then mutate the genesis block input. </p>
    </div>
  );
};

export default MutateConcept;


// WEBPACK FOOTER //
// ./src/steps/mutate-2/concept.js